import React from 'react';
import { Link } from 'react-router-dom';
const images = [
    "https://cdn.shopify.com/s/files/1/0478/6873/9739/files/Frame_460.jpg?v=1711623655",
    "https://cdn.shopify.com/s/files/1/0478/6873/9739/files/Frame_461.jpg?v=1711623656",

];

const Cards = ({ items, heading }) => {
    return (
        <div className="relative w-full mx-auto overflow-hidden">
            {
                images.map((image, index) => (
                    <img src={image} alt="" className="w-full h-auto object-cover flex-shrink-0 cursor-pointer" />
                ))
            }
        </div>
    );
};

export default Cards;
